import { HStack } from '@chakra-ui/react';
import CustomModal from '../../../components/CustomModal';
import { BuyAirtime, BuyData, PayBills } from './Bills';
import BuyAirtimeModal from './buy airtime/BuyAirtimeModal';
import BuyDataModal from './buy data/BuyDataModal';
import PayBillsModal from './pay bills/PayBillsModal';

const OtherServices = () => {
  return (
    <HStack gap='1rem' justify='space-between' wrap='wrap'>
      <CustomModal addCloseModalBtn div btnTitle={<PayBills />}>
        <PayBillsModal />
      </CustomModal>

      <CustomModal addCloseModalBtn div btnTitle={<BuyAirtime />}>
        <BuyAirtimeModal />
      </CustomModal>

      <CustomModal addCloseModalBtn div btnTitle={<BuyData />}>
        <BuyDataModal />
      </CustomModal>
    </HStack>
  );
};

export default OtherServices;
